module.exports = "<portal-edit-form portal=\"$ctrl.portal\" on-edit=\"$ctrl.changeState($event)\" on-save=\"$ctrl.saveFilter($event)\"></portal-edit-form>";